import { lazy } from 'react';
import { type RouteObject } from 'react-router';

import zones from './zones/route';

const IndexPage = lazy(() => import('./index'));

export default {
    path: '/wms',
    title: 'Skladište',
    children: [{
        index: true,
        Component: IndexPage,
    }, zones],
} satisfies RouteObject;
